module.exports = __webpack_public_path__ + "img/chargingpoint-fastcharger-rejected.abc5165b.svg";